import { Card, alpha, styled } from '@mui/material';

export const CustomCloudCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
  width: '100%',
  boxShadow: 'none',
  height: 140,
  backgroundColor: theme.palette.background.default,
  border: 'solid 1px',
  borderColor: theme.palette.divider,
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.05),
    boxShadow: theme.shadows[20],
  },
}));

export const CustomCloudListItem = styled(Card)(({ theme }) => ({
  padding: theme.spacing(1, 2),
  width: '100%',
  maxWidth: '100%',
  height: 60,
  boxShadow: 'none',
  backgroundColor: theme.palette.background.default,
  border: 'solid 1px',
  borderColor: theme.palette.divider,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.05),
    boxShadow: theme.shadows[20],
  },
}));
